var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column flex-grow-1" },
    [
      _c("v-text-field", {
        staticClass: "mr-3",
        style: { position: "relative" },
        attrs: {
          outlined: "",
          readonly: _vm.readonly,
          "hide-details": "",
          value: _vm.value,
          loading: _vm.loading || _vm.isLoading,
          disabled: _vm.disabled,
          "error-messages": _vm.returnError,
          id: _vm.idSuuggestView,
        },
        on: { focus: _vm.focusSuggest, input: _vm.showSuggest },
      }),
      _c("div", {
        ref: "suggestDropDown",
        style: { display: _vm.visibleSuggest, position: "absolute" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }